import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { getSize, getColor, TextLinkButton, TextInput, RichTextEditor, MathEnabledTextComponent, PrimaryButton, SecondaryButton } from '@lib/common';
import styled from 'styled-components';
import { Divider, Form, Space } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useForm } from 'antd/lib/form/Form';
import { useRef, memo, useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledHeadingTitle = styled.div.withConfig({
  displayName: "headingcomponent__StyledHeadingTitle",
  componentId: "sc-1704qnf-0"
})(["font-weight:700;font-size:", ";padding:", ";"], getSize('typo20'), getSize('padding0'));
var StyledHeadingTitleWrapper = styled.div.withConfig({
  displayName: "headingcomponent__StyledHeadingTitleWrapper",
  componentId: "sc-1704qnf-1"
})(["display:flex;justify-content:space-between;align-items:start;min-height:64px;padding:", " ", " ", " ", ";"], getSize('padding8'), getSize('padding0'), getSize('padding16'), getSize('padding0'));
var StyledHeadingWrapper = styled(Form).withConfig({
  displayName: "headingcomponent__StyledHeadingWrapper",
  componentId: "sc-1704qnf-2"
})(["position:relative;box-shadow:0px 3px 6px rgba(0,0,0,0.12);background:", ";border-radius:", ";margin-bottom:", ";"], getColor('fillBgWhite'), getSize('radiusSm'), getSize('padding16'));
var StyledLine = styled(Divider).withConfig({
  displayName: "headingcomponent__StyledLine",
  componentId: "sc-1704qnf-3"
})(["margin:", ";color:", ";"], getSize('padding0'), getColor('contentMinimum'));
var StyledHeading = styled.div.withConfig({
  displayName: "headingcomponent__StyledHeading",
  componentId: "sc-1704qnf-4"
})(["padding:", " ", ";border-radius:", ";border:2px solid ", ";"], getSize('padding16'), getSize('padding24'), getSize('radiusSm'), function (_ref) {
  var $focus = _ref.$focus;
  return $focus ? getColor('fillIntActive') : getColor('fillBgWhite');
});
var StyledDescription = styled(MathEnabledTextComponent).withConfig({
  displayName: "headingcomponent__StyledDescription",
  componentId: "sc-1704qnf-5"
})(["min-height:40px;padding:", " ", ";img{max-width:100%;}"], getSize('padding16'), getSize('padding0'));
var StyledHeadingTileContainer = styled.div.withConfig({
  displayName: "headingcomponent__StyledHeadingTileContainer",
  componentId: "sc-1704qnf-6"
})(["display:flex;min-height:", ";padding:", " ", " ", " ", ";"], getSize('padding64'), getSize('padding8'), getSize('padding0'), getSize('padding16'), getSize('padding0'));
var TitleArea = styled.div.withConfig({
  displayName: "headingcomponent__TitleArea",
  componentId: "sc-1704qnf-7"
})(["flex:1;"]);
var TitleInput = styled(TextInput).withConfig({
  displayName: "headingcomponent__TitleInput",
  componentId: "sc-1704qnf-8"
})(["font-weight:700;font-size:", ";padding:", ";width:100%;&.ant-input{font-size:", ";font-weight:700;}"], getSize('typo20'), getSize('padding0'), getSize('typo20'));
var StyledGroupButton = styled(Space).withConfig({
  displayName: "headingcomponent__StyledGroupButton",
  componentId: "sc-1704qnf-9"
})(["display:flex;flex-direction:row-reverse;"]);
export var HeadingFactory = /*#__PURE__*/memo(function (_ref2) {
  var heading = _ref2.heading,
      selectedFormItemId = _ref2.selectedFormItemId,
      editingFormItemId = _ref2.editingFormItemId,
      headingLabels = _ref2.headingLabels,
      editorLabels = _ref2.editorLabels,
      onSaveHeading = _ref2.onSaveHeading,
      onCancel = _ref2.onCancel,
      onEdit = _ref2.onEdit,
      onDelete = _ref2.onDelete,
      onSelect = _ref2.onSelect;
  var isEditing = editingFormItemId === heading.id.toString();

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var richTextEditorRef = useRef(null); // Log heading data for debugging

  useEffect(function () {
    if (isEditing) {
      // Reset the form first to clear any previous values
      form.resetFields(); // Explicitly set the form values with a slight delay to ensure the DOM is ready

      setTimeout(function () {
        form.setFieldsValue({
          title: heading.title,
          description: heading.description
        });
      }, 50);
    }
  }, [isEditing, heading, form]);

  if (isEditing) {
    return /*#__PURE__*/_jsx(StyledHeadingWrapper, {
      form: form,
      initialValues: {
        title: heading.title,
        description: heading.description
      },
      preserve: false,
      onFinish: onSaveHeading,
      layout: "vertical",
      children: /*#__PURE__*/_jsxs(StyledHeading, {
        $focus: true,
        children: [/*#__PURE__*/_jsxs(StyledHeadingTileContainer, {
          children: [/*#__PURE__*/_jsx(TitleArea, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "title",
              initialValue: heading.title,
              rules: [{
                required: true,
                message: 'Title is required'
              }],
              children: /*#__PURE__*/_jsx(TitleInput, {
                placeholder: headingLabels.placeholderHeadingName,
                defaultValue: heading.title
              })
            })
          }), /*#__PURE__*/_jsx(TextLinkButton, {
            onClick: function onClick(e) {
              e.stopPropagation();
              onDelete(heading.id.toString());
            },
            icon: /*#__PURE__*/_jsx(DeleteOutlined, {})
          })]
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "description",
          initialValue: heading.description,
          children: /*#__PURE__*/_jsx(RichTextEditor, {
            ref: richTextEditorRef,
            placeholder: headingLabels.placeholderHeadingDescription,
            editorLabels: editorLabels,
            content: heading.description
          })
        }), /*#__PURE__*/_jsxs(StyledGroupButton, {
          children: [/*#__PURE__*/_jsx(PrimaryButton, {
            htmlType: "submit",
            children: headingLabels.saveHeading
          }), /*#__PURE__*/_jsx(SecondaryButton, {
            onClick: onCancel,
            children: headingLabels.cancel
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/_jsx(StyledHeadingWrapper, {
    children: /*#__PURE__*/_jsxs(StyledHeading, {
      $focus: selectedFormItemId === heading.id.toString(),
      onClick: function onClick() {
        return onSelect(heading.id.toString());
      },
      children: [/*#__PURE__*/_jsxs(StyledHeadingTitleWrapper, {
        children: [/*#__PURE__*/_jsx(StyledHeadingTitle, {
          children: heading.title
        }), /*#__PURE__*/_jsxs(Space, {
          children: [/*#__PURE__*/_jsx(SecondaryButton, {
            icon: /*#__PURE__*/_jsx(EditOutlined, {}),
            onClick: function onClick() {
              return onEdit(heading.id.toString());
            },
            children: headingLabels.editHeading
          }), /*#__PURE__*/_jsx(TextLinkButton, {
            onClick: function onClick(e) {
              e.stopPropagation(); // Prevent triggering onSelect

              onDelete(heading.id.toString());
            },
            icon: /*#__PURE__*/_jsx(DeleteOutlined, {})
          })]
        })]
      }), /*#__PURE__*/_jsx(StyledLine, {}), /*#__PURE__*/_jsx(StyledDescription, {
        value: heading.description
      })]
    })
  });
});